import localforage from 'localforage'

const videoEventsStore = localforage.createInstance({
  name: 'hom-video-events',
  storeName: 'video-stat-events',
  description: 'Video stat events',
})

export default videoEventsStore
